import React from 'react';
import { controlAnchorProps } from 'modules/Common/utils/gapAnchor';

// Styled native checkbox. We avoid pulling in @radix-ui/react-checkbox
// (not currently a dep) — a native input + accent-color is enough for the
// few places forms need a checkbox, and it stays accessible by default.
export default function CheckboxField({ field, fieldState, id, inlineLabel, disabled, anchor }) {
  return (
    <label
      htmlFor={id}
      className={`inline-flex items-center gap-2 text-sm ${
        disabled ? 'text-slate-400 cursor-not-allowed' : 'text-slate-700 cursor-pointer'
      }`}
    >
      <input
        type="checkbox"
        id={id}
        name={field.name}
        checked={!!field.value}
        onChange={(e) => field.onChange(e.target.checked)}
        onBlur={field.onBlur}
        disabled={disabled}
        {...controlAnchorProps(anchor, !field.value)}
        className={`w-4 h-4 rounded border-slate-300 accent-primaryColor focus:outline-none focus:ring-1 focus:ring-primaryColor/40 ${
          fieldState?.error ? 'border-red-400' : ''
        }`}
      />
      {inlineLabel ? <span>{inlineLabel}</span> : null}
    </label>
  );
}
